module.exports = __webpack_public_path__ + "img/en_left.b7a76982.png";